import styled from 'styled-components'

export default styled.label`
  display: block;
  font-size: 1.325rem;
  color: ${({ theme }) => theme.variables['$brand-primary']};
  font-weight: bold;
`
